import React, {Component, PropTypes} from 'react'
import {Grid, Row, Col} from 'react-bootstrap'
import {Loader} from '../../core/redux/loading'
import i18n from '../i18n'
import style from './UnauthUserLayout.less'

class UnauthUserLayout extends Component {
    static propTypes = {
    }

    render() {
        const {children} = this.props

        return (
            <div className={style.default}>
                <Grid>
                    <Loader>
                        <Row>
                            <Col sm={6} smOffset={3}>
                                <p>{i18n.welcome}</p>
                                {children}
                            </Col>
                        </Row>
                    </Loader>
                </Grid>
            </div>
        )
    }
}

export default UnauthUserLayout


// WEBPACK FOOTER //
// ./lib/user/components/UnauthUserLayout.js